export default __webpack_public_path__ + "static/media/background.716f58ad.png";